export default __webpack_public_path__ + "locales/ko-KR/Files.json?hash=205c0c46e670ff0bfe2d7ede1d9977c9";